import { POS_API_URL } from "../data/billzappPlans";

// Calls the BillZapp server's API (`token` is a website login). Resolves with the response
// body, or throws an Error carrying the server's message and the HTTP status (`err.status`).
export async function requestPos(path, { method = "GET", body, token } = {}) {
  let response;
  try {
    response = await fetch(`${POS_API_URL}${path}`, {
      method,
      headers: {
        ...(body !== undefined && { "Content-Type": "application/json" }),
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch (err) {
    throw new Error("Could not reach the server. Check your connection and try again.");
  }

  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.success) {
    const error = new Error(data.message || "Something went wrong. Please try again.");
    error.status = response.status;
    throw error;
  }
  return data;
}
